import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import { contentAddRemoveModal } from "ContentActions";
import { patchFeatures } from "GeneralTabAction";
import { fetchFeature } from "GeneralTabAction";
import { updateUnsavedChanges } from "DashboardMenuAction";
import ListItem from "FeaturesItem";
import Features from "FeaturesComponent";
import LocaleStrings from "Languages";

class ShowHideFeature extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
    this.featureRef = React.createRef();
  }

  close = () => {
    this.props.contentAddRemoveModal({ showModal: false });
    this.props.updateUnsavedChanges(false);
    this.setState({ loading: false });
  };

  submitFeaturesDataCallback = (values, appBottomMenu) => {
    let { session, pathName } = this.props;

    this.setState({ loading: true });
    this.props.patchFeatures(
      session,
      { newFeatures: values, bottomMenu: appBottomMenu },
      true,
      (response) => {
        this.props.fetchFeature(session, (res) => {
          var check = _.filter(values, (obj) => {
            return obj.bsClass == pathName;
          });

          if (check && check.length > 0 && check[0].isenabled === false) {
            this.props.history.push(`/dashboard/content`);
          }

          this.props.showSuccess("Features updated successfully");
          this.close();
        });
      },
      (error) => {
        this.props.showError(COMMON_FAIL_MESSAGE);
        this.setState({ loading: false });
      }
    );
  };

  submit = () => {
    this.featureRef.current.submitFeaturesData();
  };

  renderContentItems = () => {
    if (this.props.selectedFeatures.length % 2 > 0) {
      let obj = {
        apptabid: 0,
        bsClass: "",
        description: "",
        isenabled: true,
        label: "extra_blank",
        taborder: 0,
      };
      this.props.selectedFeatures.push(obj);
    }

    var items = _.map(this.props.selectedFeatures, (feature) => (
      <ListItem key={feature.bsClass} feature={feature} />
    ));
    return items;
  };

  render() {
    let { contentAddRemoveModalStatus, unsavedChanges } = this.props;
    let { loading } = this.state;

    return (
      <Modal
        className="modal-container"
        show={
          contentAddRemoveModalStatus &&
          contentAddRemoveModalStatus.showModal === true
            ? true
            : false
        }
        dialogClassName="modal-lg"
        onHide={this.close}
        animation={true}
      >
        <Modal.Header>
          <div className="custom-modal-title">
            Choose the features that you would like to see on your event app
          </div>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={this.close}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="col-md-12 featureWap">
              {/* <ul className="feature-ul ul-list-column2">{this.renderContentItems()}</ul> */}
              <Features
                submitFeaturesDataHandler={this.submitFeaturesDataCallback}
                ref={this.featureRef}
                displaySection="content"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-custom-white" onClick={this.close}>
            {LocaleStrings.button_close}
          </Button>
          <Button
            loading={loading}
            disabled={!unsavedChanges}
            className="btn-custom-blue"
            onClick={this.submit}
          >
            {LocaleStrings.button_save}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var pathName = _.last(_.split(ownProps.history.location.pathname, "/"));

  return {
    session: state.session,
    contentAddRemoveModalStatus: state.contentAddRemoveModal,
    selectedFeatures: state.selectedFeatures,
    unsavedChanges: state.unsavedChanges,
    pathName,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  contentAddRemoveModal,
  updateUnsavedChanges,
  patchFeatures,
  fetchFeature,
})(ShowHideFeature);
